<div class="flex h-full w-full flex-nowrap">
  <div class="h-full w-80 shrink-0 border-x-0 border-y-0 border-r border-solid border-pill">
    <app-profile-selector
      #filterProfileSelector
      [profiles]="profiles"
      [lastSelectedProfile]="appliedProfile"
      [isDirty]="formGroup?.dirty"
      [config]="config"
      [loading]="loading"
      (editProfileClicked)="editProfileClicked.emit($event)"
      (createNewProfileClicked)="createProfileClicked.emit()"
      (copyProfileClicked)="copyProfileClicked.emit($event)"
      (deleteProfileClicked)="deleteProfileClicked.emit($event)"
    ></app-profile-selector>
  </div>
  <div class="flex h-full min-w-0 flex-1 flex-col px-6 pb-3.5 pt-3.5">
    <ng-container [ngSwitch]="settingsContentPanelState">
      <ng-container *ngSwitchCase="PanelStates.Edit">
        <ng-container *ngTemplateOutlet="editContainer"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="PanelStates.NoSelectedProfile">
        <ng-container *ngTemplateOutlet="filtersContainer"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="PanelStates.NoFilters">
        <ng-container *ngTemplateOutlet="noProfilesContainer"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #editContainer>
  <!-- A fixed h-12 with mb-3.5 mirrors the pane's pt-3.5, so the row sits evenly between the rule above and
       the content's rule below. The rename field is 50px (Material's transparent 0.25em outline margin), and
       overflows into that space symmetrically instead of growing the row. -->
  <header class="mb-3.5 flex h-12 shrink-0 items-center gap-3">
    <div class="min-w-0 flex-1"><ng-content select="[header-container]"></ng-content></div>
    <span
      *ngIf="selectedProfile?.isReadOnly"
      class="inline-flex shrink-0 items-center gap-1 rounded-full bg-surface-muted px-2.5 py-1 text-xs text-gray-600"
    >
      <mat-icon class="tl-icon-sm">visibility</mat-icon>{{ 'General.ViewOnly' | translate }}
    </span>
    <span
      *ngIf="isApplied; else applyButton"
      class="inline-flex shrink-0 items-center gap-1 rounded-full bg-status-green-soft px-2.5 py-1 text-xs font-medium text-status-green"
    >
      <mat-icon class="tl-icon-sm">check_circle</mat-icon>{{ 'Profiles.Active' | translate }}
    </span>
    <!-- A disabled button shows no tooltip, so the reason sits on a wrapper. -->
    <ng-template #applyButton>
      <span class="shrink-0" [matTooltip]="formGroup?.dirty ? ('Profiles.SaveBeforeApplying' | translate) : ''">
        <button mat-stroked-button color="primary" type="button" [disabled]="formGroup?.dirty" (click)="onApply()">
          {{ 'Profiles.ApplyToGrid' | translate }}
        </button>
      </span>
    </ng-template>
  </header>
  <main class="min-h-0 flex-1 overflow-auto"><ng-content select="[edit-container]"></ng-content></main>
  <footer class="border-x-0 border-y-0 border-t border-solid border-pill pt-6">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </footer>
</ng-template>

<ng-template #filtersContainer>
  <ng-content select="[filters-container]"></ng-content>
</ng-template>

<ng-template #noProfilesContainer>
  <ng-content select="[no-profiles-container]"></ng-content>
</ng-template>

<!-- Reset discards edits, so it sits apart on the left; the right group reads least to most
     committal - Cancel, Preview, Save - with Save as the only filled button. -->
<ng-template #footer>
  <div class="flex items-center gap-2">
    <button mat-button type="button" *ngIf="displayReset" (click)="onReset()" [disabled]="!formGroup?.dirty">
      {{ 'General.Reset' | translate }}
    </button>
    <div class="ml-auto flex items-center gap-2">
      <button mat-button type="button" *ngIf="displayCancel" (click)="onCancel()">
        {{ 'General.Cancel' | translate }}
      </button>
      <button
        mat-stroked-button
        type="button"
        color="primary"
        *ngIf="displayPreview"
        (click)="previewProfileClicked.emit()"
      >
        {{ 'General.Preview' | translate }}
      </button>
      <button
        mat-flat-button
        type="button"
        color="primary"
        *ngIf="displaySave"
        [disabled]="disableSave"
        (click)="onSave()"
      >
        {{ 'General.Save' | translate }}
      </button>
    </div>
  </div>
</ng-template>
